import { MessageCircle } from "lucide-react";
import { useLang } from "../context/LanguageContext";

// Configurable WhatsApp number. Update the digits (no + or spaces) to change destination.
const WHATSAPP_NUMBER = "994515169301";

export default function WhatsAppFab() {
  const { t } = useLang();
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    "Hello Planet Group Baku — please send me your best price list today!"
  )}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t.common.chatWhatsapp}
      data-testid="whatsapp-fab"
      className="fixed bottom-6 right-6 z-50 group flex items-center gap-3 bg-[#25D366] text-white pl-4 pr-5 py-3 shadow-[0_18px_40px_-10px_rgba(37,211,102,0.6)] hover:bg-[#1DA851] transition-colors"
      style={{ borderRadius: 0 }}
    >
      <MessageCircle size={20} />
      <span className="text-sm font-semibold tracking-wide uppercase">
        {t.common.chatWhatsapp}
      </span>
    </a>
  );
}
